import { render } from "./VOverview.vue?vue&type=template&id=5d36ca01"
import script from "./VOverview.vue?vue&type=script&lang=js"
export * from "./VOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__